import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { z } from 'zod'

import Logo from '@/containers/logo'

import Spinner from '@/components/spinner'
import { ModeToggle } from '@/components/theme/mode-toggle.tsx'
import { TooltipProvider } from '@/components/tooltip'

import { authTokenAtom } from '../../state/authToken'
import { useIdentity } from '../../state/identity'

import AcceptInviteForm from './-components/acceptInviteForm'
import SignUpForm from './-components/signUpForm'

const SignUp = () => {
    const { identity } = useIdentity()
    const [authToken] = useAtom(authTokenAtom)
    const router = useRouter()
    const { redirect, invite_token } = Route.useSearch()

    useEffect(() => {
        if (identity) {
            console.debug('Identified, redirecting')
            // Hard refresh redirect on signUp do avoid potential state issues
            location.href = redirect ?? '/'
        }
    }, [identity, redirect, router.history])

    if (identity || authToken) {
        return <Spinner size="sm" absolute />
    }

    const title = invite_token ? 'Accept Invite' : 'Sign Up'

    return (
        <>
            <TooltipProvider>
                <div className="relative grid h-screen flex-col items-center justify-center px-4 lg:max-w-none lg:grid-cols-2 lg:px-0">
                    <div className="absolute right-8 top-8">
                        <ModeToggle />
                    </div>
                    <div className="mx-auto hidden h-full w-full flex-col items-center justify-center bg-muted lg:flex">
                        <Logo className="mb-4 mr-2" />
                        <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
                    </div>
                    <div className="lg:p-8">
                        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
                            <div className="visible mx-auto mb-12 flex w-full flex-col items-center justify-center text-center lg:hidden">
                                <Logo className="mb-4 mr-2" />
                                <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
                            </div>
                            <div className="flex flex-col space-y-2 text-center">
                                <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
                            </div>
                            {invite_token ? <AcceptInviteForm inviteToken={invite_token} /> : <SignUpForm />}
                        </div>
                    </div>
                </div>
            </TooltipProvider>
        </>
    )
}

const signUpSearchSchema = z.object({
    redirect: z.string().optional(),
    invite_token: z.string().optional(),
})

export const Route = createFileRoute('/signup/')({
    validateSearch: signUpSearchSchema,
    component: SignUp,
})
